export function logError(...args) {
    if (process.env.NODE_ENV !== 'production' && typeof document !== 'undefined') {
        console.error(...args);
    }
}
//# sourceMappingURL=logError.js.map